<app-loader></app-loader>
<div class="card breadcrumbs">
    <div class="table-top common-flex-between view-active">
        <ul *ngIf="role !== 'SuperAdmin'" class="list-none breadcrumbs-outer">
            <li class="active-dashboard">
                <a [routerLink]="['/manager/dashboard']" class="no-underline line-height-3 cursor-pointer">Dashboard</a>
            </li>
            <li class="px-2 breadcrumbs-divider">
                <span>|</span>
            </li>
            <li class="back-link">
                <a [routerLink]="['/manager/parking']" class="no-underline line-height-3 cursor-pointer">Parking
                    Locations</a>
            </li>
            <li class="px-2 breadcrumbs-divider">
                <span>|</span>
            </li>
            <li class="current-link">
                <span class="line-height-3">View Parking</span>
            </li>
        </ul>
    </div>
</div>

<div class="main-card parking-preview" *ngIf="parkingLotData">

    <div class="table-top common-flex-between view-active">
        <h3>
            {{parkingLotData.name}}
            <div>
                <div class="common-active"
                    *ngIf="!parkingLotData.isActive && !parkingLotData.isComingSoon && !parkingLotData.isDeleted">
                    <span></span> Inactive
                </div>
                <div class="common-active green-active"
                    *ngIf="parkingLotData.isActive && !parkingLotData.isComingSoon && !parkingLotData.isDeleted">
                    <span></span> Active
                </div>
                <div class="common-active orange-active" *ngIf="parkingLotData.isComingSoon">
                    <span></span> Coming Soon
                </div>
                <div class="common-active orange-active" *ngIf="parkingLotData.isDeleted">
                    <span></span> Suspended
                </div>
            </div>
        </h3>
        <div *ngIf="editParkingCheck && !parkingLotData.isDeleted" class="common-flex-between common-margin-bottom">
            <p-button label="Edit" (onClick)="editParkingNavigation()"></p-button>
        </div>
    </div>
    <div class="custom-select martial-main-outer responsive-mob date-ranges availability-summary">
        <div class="martial-outer">
            <p class="date-range-label">Displaying data from {{ startDate | date:'MM.dd.yyyy' }} to {{ endDate | date:'MM.dd.yyyy' }}</p>
        </div>
        <div class="availability-lines">
            <p>Full-Length: {{ fullLengthAvailable }} of {{ fullLengthTotal }} available</p>
            <p>Half-Length: {{ halfLengthAvailable }} of {{ halfLengthTotal }} available</p>
        </div>
    </div>
    <div class="grid middle-line">
        <div class="col-12 lg:col-6">
            <div class="view-leftside">
                <div class="grid">
                    <div class="col-12 lg:col-6">
                        <div class="name-outer">
                            <h4>Parking Name</h4>
                            <p>{{parkingLotData.name}}</p>
                        </div>
                    </div>
                    <div class="col-12 lg:col-6">
                        <div class="name-outer">
                            <h4>Access Code</h4>
                            <p *ngIf="parkingLotData.accessCode">One Time - {{parkingLotData?.accessCode}} | Monthly -
                                {{parkingLotData?.monthlyAccessCode}}</p>
                            <p *ngIf="!parkingLotData.accessCode">System Generated</p>
                        </div>
                    </div>
                </div>
                <div class="name-outer">
                    <h4>Parking Location</h4>
                    <p>{{parkingLotData?.location.address}}</p>
                </div>
                <div class="name-outer">
                    <h4>Parking Instructions</h4>
                    <p class="instruction-text"><strong>One Time Bookings Instruction :</strong>
                        {{getPlainText(parkingLotData?.termsAndCondition)}}</p>
                    <p class="instruction-text"><strong>Recurring Bookings Instructions
                            :</strong> {{getPlainText(parkingLotData?.termsAndConditionRecurring)}}</p>
                </div>

                <div *ngIf="parkingLotData?.termsAndConditionFilePath" class="doc-close">
                    <a [href]="parkingLotData?.termsAndConditionFilePath" target="_blank">
                        Parking Location Terms & Conditions
                    </a>
                </div>

                <div class="name-outer">
                    <h4>Amenities</h4>
                    <div class="fare-outer facilities"
                        *ngIf="parkingLotData.parkingLotFacility.length > 0; else no_facilities">
                        <ul>
                            <li *ngFor="let facility of parkingLotData.parkingLotFacility">
                                <div class="facility-list">
                                    <span class="custom-diver"><svg width="13" height="13" viewBox="0 0 13 13"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M2.17894 6.00723C1.94919 6.00787 1.72431 6.07355 1.53033 6.19667C1.33635 6.31979 1.18118 6.49531 1.08279 6.70293C0.984405 6.91055 0.946808 7.14179 0.974354 7.36988C1.0019 7.59798 1.09346 7.81362 1.23845 7.99185L4.32923 11.7781C4.43943 11.9149 4.58069 12.0235 4.74128 12.0947C4.90186 12.166 5.07714 12.198 5.25255 12.1879C5.6277 12.1677 5.9664 11.9671 6.18234 11.6371L12.6027 1.29715C12.6037 1.29543 12.6048 1.29372 12.606 1.29203C12.6662 1.19953 12.6467 1.01623 12.5223 0.901078C12.4882 0.869455 12.4479 0.845161 12.404 0.82969C12.3601 0.814219 12.3135 0.807899 12.267 0.81112C12.2206 0.814341 12.1753 0.827035 12.134 0.848418C12.0926 0.869802 12.0561 0.899424 12.0266 0.935459C12.0243 0.938293 12.022 0.941083 12.0195 0.943831L5.54452 8.25961C5.51989 8.28745 5.48996 8.31011 5.45649 8.32629C5.42302 8.34247 5.38667 8.35183 5.34954 8.35384C5.31242 8.35585 5.27527 8.35046 5.24025 8.33799C5.20523 8.32552 5.17303 8.30621 5.14554 8.28119L2.99661 6.32565C2.77342 6.12106 2.48171 6.00746 2.17894 6.00723Z"
                                                fill="#464A4B" />
                                        </svg>
                                    </span>
                                    <span>{{facility?.facilityName || '-'}}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <ng-template #no_facilities>
                        <p>-</p>
                    </ng-template>
                </div>
                <div *ngFor="let trucks of parkingLotData.truckType" class="spot-type"
                    [ngClass]="{'full-length': trucks.vehicleName.includes('Full-Length'), 'half-length': trucks.vehicleName.includes('Half-Length')}">
                    <h4>Spot Type - <span *ngIf="trucks.vehicleName.includes('Full-Length')">Full Length</span>
                        <span *ngIf="!trucks.vehicleName.includes('Full-Length')">Half Length</span>
                    </h4>
                    <div class="public-main">
                        <div class="public-rates">
                            <h5>Public Rate</h5>
                            <div class="fare-outer fare-charge">
                                <ul>
                                    <li *ngIf="trucks.fareChargesDaily">Daily Rate - ${{ trucks.fareChargesDaily }}</li>
                                    <li *ngIf="trucks.fareChargesDaily > 0 && (trucks.fareChargesMonthly > 0)"
                                        class="custom-diver"> | </li>
                                    <li *ngIf="trucks.fareChargesMonthly">Monthly Rate - ${{ trucks.fareChargesMonthly
                                        }}</li>
                                </ul>
                            </div>
                        </div>
                        <div *ngFor="let specialRates of groupedRates" class="public-table">
                            <div *ngIf="specialRates.spotTypeName === trucks.vehicleName">
                                <p-table [value]="[specialRates]">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th scope="col">Code</th>
                                            <th scope="col">Daily Rate ($)</th>
                                            <th scope="col">Monthly Rate ($)</th>
                                            <th scope="col" *ngIf="specialRates.description">Description</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-truck>
                                        <ng-container *ngFor="let rate of truck.rates">
                                            <tr>
                                                <td>
                                                    <p class="custom-text">{{ rate.code ? rate.code : '-' }}</p>
                                                </td>
                                                <td>
                                                    <p class="custom-text">{{ rate.dailyRate ? rate.dailyRate : '-' }}
                                                    </p>
                                                </td>
                                                <td>
                                                    <p class="custom-text">{{ rate.monthlyRate ? rate.monthlyRate : '-'
                                                        }}</p>
                                                </td>
                                                <td *ngIf="rate.description">
                                                    <div class="description-tooltip">
                                                        <app-tooltip [tooltipMessage]="rate.description"
                                                            [addClass]="'custom-tooltip-discription-width'"></app-tooltip>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 lg:col-6">
            <div class="view-leftside view-right">
                <ng-container *ngIf="!parkingLotData.isParkAnywhere; else parkAnywhereNote">
                    <div class="name-outer spot-status-panel">
                        <div class="spot-status-header">
                            <h4>Spot Status</h4>
                            <div class="spot-status-date custom-select">
                                <div class="from-date">
                                    <div class="date-input">
                                        <p-calendar
                                            #spotStatusStartDate
                                            [showIcon]="false"
                                            [readonlyInput]="true"
                                            dateFormat="M dd, yy"
                                            placeholder="Start date"
                                            [inputStyle]="{'width':'95%'}"
                                            [maxDate]="endDate"
                                            [ngModel]="startDate"
                                            (onSelect)="onStartDateChange($event)">
                                        </p-calendar>
                                        <img [calendarOpener]="spotStatusStartDate" src="assets/images/date-calender.png" alt="calendar" />
                                    </div>
                                    <span>To</span>
                                    <div class="date-input">
                                        <p-calendar
                                            #spotStatusEndDate
                                            [showIcon]="false"
                                            [readonlyInput]="true"
                                            dateFormat="M dd, yy"
                                            placeholder="End date"
                                            [inputStyle]="{'width':'95%'}"
                                            [minDate]="startDate"
                                            [ngModel]="endDate"
                                            (onSelect)="onEndDateChange($event)">
                                        </p-calendar>
                                        <img [calendarOpener]="spotStatusEndDate" src="assets/images/date-calender.png" alt="calendar" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="spot-status-table-wrapper">
                            <table class="spot-status-table">
                                <thead>
                                    <tr>
                                        <th scope="col" class="toggle-column"></th>
                                        <th scope="col" (click)="setSort('spotName')" class="sortable"
                                            [class.active]="sortKey === 'spotName'">
                                            Spot number
                                            <span class="sort-indicator" [class.desc]="sortKey === 'spotName' && sortDirection === 'desc'">▲</span>
                                        </th>
                                        <th scope="col" (click)="setSort('spotType')" class="sortable"
                                            [class.active]="sortKey === 'spotType'">
                                            Type
                                            <span class="sort-indicator" [class.desc]="sortKey === 'spotType' && sortDirection === 'desc'">▲</span>
                                        </th>
                                        <th scope="col" (click)="setSort('statusText')" class="sortable"
                                            [class.active]="sortKey === 'statusText'">
                                            Status
                                            <span class="sort-indicator" [class.desc]="sortKey === 'statusText' && sortDirection === 'desc'">▲</span>
                                        </th>
                                        <th scope="col" (click)="setSort('bookingTypeText')" class="sortable"
                                            [class.active]="sortKey === 'bookingTypeText'">
                                            Booking Type
                                            <span class="sort-indicator" [class.desc]="sortKey === 'bookingTypeText' && sortDirection === 'desc'">▲</span>
                                        </th>
                                        <th scope="col" (click)="setSort('arrivalDate')" class="sortable"
                                            [class.active]="sortKey === 'arrivalDate'">
                                            Arrival Date &amp; Time
                                            <span class="sort-indicator" [class.desc]="sortKey === 'arrivalDate' && sortDirection === 'desc'">▲</span>
                                        </th>
                                        <th scope="col" (click)="setSort('departureDate')" class="sortable"
                                            [class.active]="sortKey === 'departureDate'">
                                            Departure Date &amp; Time
                                            <span class="sort-indicator" [class.desc]="sortKey === 'departureDate' && sortDirection === 'desc'">▲</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let row of sortedSlotStatusRows">
                                        <tr>
                                            <td class="toggle-column">
                                                <button
                                                    *ngIf="row.bookingRows.length > 1"
                                                    type="button"
                                                    class="row-toggle"
                                                    (click)="toggleSpotRow(row)"
                                                    [attr.aria-expanded]="isExpanded(row)">
                                                    {{ isExpanded(row) ? '-' : '+' }}
                                                </button>
                                            </td>
                                            <td>{{ row.spotName }}</td>
                                            <td>{{ row.spotType }}</td>
                                            <td>
                                                <a *ngIf="row.statusLink"
                                                    [routerLink]="row.statusLink"
                                                    [queryParams]="row.statusQueryParams">
                                                    {{ row.statusText }}
                                                </a>
                                                <span *ngIf="!row.statusLink">{{ row.statusText }}</span>
                                            </td>
                                            <td>{{ row.bookingTypeText }}</td>
                                            <td>{{ row.arrivalDate ? (row.arrivalDate | date:'MM.dd.yyyy HH:mm') : '-' }}</td>
                                            <td>{{ row.showDepartureDate ? (row.departureDate ? (row.departureDate | date:'MM.dd.yyyy HH:mm') : '-') : '-' }}</td>
                                        </tr>
                                        <tr *ngIf="isExpanded(row)" class="spot-status-detail-row">
                                            <td colspan="7">
                                                <table class="spot-status-detail-table">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Email</th>
                                                            <th scope="col">Booking Type</th>
                                                            <th scope="col">Arrival Date &amp; Time</th>
                                                            <th scope="col">Departure Date &amp; Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let bookingRow of row.bookingRows">
                                                            <td>
                                                                <a *ngIf="bookingRow.statusLink"
                                                                    [routerLink]="bookingRow.statusLink"
                                                                    [queryParams]="bookingRow.statusQueryParams">
                                                                    {{ bookingRow.email || '-' }}
                                                                </a>
                                                                <span *ngIf="!bookingRow.statusLink">{{ bookingRow.email || '-' }}</span>
                                                            </td>
                                                            <td>{{ bookingRow.bookingTypeText }}</td>
                                                            <td>{{ bookingRow.arrivalDate ? (bookingRow.arrivalDate | date:'MM.dd.yyyy HH:mm') : '-' }}</td>
                                                            <td>{{ bookingRow.showDepartureDate ? (bookingRow.departureDate ? (bookingRow.departureDate | date:'MM.dd.yyyy HH:mm') : '-') : '-' }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                            <div class="spot-status-empty" *ngIf="slotStatusRows.length === 0">
                                No spots available
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #parkAnywhereNote>
                    <div class="name-outer spot-status-panel">
                        <h4>Spot Status</h4>
                        <p>Park Anywhere lot. No individual spots to display.</p>
                    </div>
                </ng-template>
                <div class="name-outer">
                    <h4>Parking Plan</h4>

                    <div class="parking-plan" *ngIf="parkingLotData.parkingLotLayout;else no_parking_layout">
                        <p-image *ngIf="!parkingLotData.isParkingLotLayoutDoc;else document" p-image-preview-indicator
                            [src]="parkingLotData.parkingLotLayout" alt="Image" [preview]="true"></p-image>
                        <ng-template #document>
                            <a [href]="parkingLotData.parkingLotLayout" target="_blank">
                                <span>View Document</span>
                            </a>
                        </ng-template>
                    </div>
                    <ng-template #no_parking_layout>
                        <div class="blank-img">
                            <p>No Parking Plan Avaliable</p>
                        </div>
                    </ng-template>
                </div>
                <div class="name-outer">
                    <h4>Uploaded Parking Photo</h4>
                    <div class="grid" *ngIf="parkingLotData.parkingLotImages.length>0;else no_parking_img">
                        <div class="col-6 lg:col-3" *ngFor="let parkingLotImage of parkingLotData.parkingLotImages">
                            <div class="parking-plan">
                                <p-image [preview]="true" [src]="parkingLotImage.imagePath" alt="Image"></p-image>
                            </div>
                        </div>
                    </div>
                    <ng-template #no_parking_img>
                        <div class="blank-img">
                            <p>No Parking Images Avaliable</p>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>